<template>
  <div class="login content">
    <header></header>
    <div class="login-wrapper">
      <div class="login-content pb-2">
        <p>Logging out...</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  layout: "blank",
  data() {
    return {
      //
    };
  },
  methods: {
    ...mapActions("users", ["logoutUser"]),
  },
  beforeCreate() {
    const userToken = this.$userPrefs.getCurrentToken();
    if (!userToken) this.$router.push("/");
    this.$http.setAuthorisationToken(userToken);
  },
  async created() {
    await this.logoutUser();
    localStorage.clear();
    window.location.assign("/");
  },
};
</script>

<style lang="scss" scoped>
.login {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;

  header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: center;
    padding: 35px 35px 0;
  }

  &-wrapper {
    height: 100vh;
  }

  &-content {
    width: 400px;
    max-width: 95%;
    position: relative;
    top: 50%;
    left: 50%;
    padding: 20px;
    flex-direction: column;
    justify-content: center;
    background-color: rgba(255, 255, 255, 0.8);
    transform: translateY(-50%) translateX(-50%);
    border-radius: 5px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  }
}
</style>
